// Require Editor JS files.
import 'froala-editor/js/froala_editor.pkgd.min.js';
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/char_counter.min.js';
import 'froala-editor/js/plugins/code_beautifier.min.js';
import 'froala-editor/js/plugins/code_view.min.js';
import 'froala-editor/js/plugins/draggable.min.js';
import 'froala-editor/js/plugins/emoticons.min.js';
import 'froala-editor/js/plugins/entities.min.js';
import 'froala-editor/js/plugins/font_family.min.js';
import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/fullscreen.min.js';
import 'froala-editor/js/plugins/help.min.js';
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/video.min.js';
import 'froala-editor/js/plugins/trim_video.min.js';
import 'froala-editor/js/plugins/file.min.js';
import 'froala-editor/js/plugins/inline_class.min.js';
import 'froala-editor/js/plugins/line_breaker.min.js';
import 'froala-editor/js/plugins/line_height.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import 'froala-editor/js/plugins/paragraph_style.min.js';
import 'froala-editor/js/plugins/print.min.js';
import 'froala-editor/js/plugins/quote.min.js';
import 'froala-editor/js/plugins/save.min.js';
import 'froala-editor/js/plugins/special_characters.min.js';
import 'froala-editor/js/plugins/table.min.js';
import 'froala-editor/js/plugins/url.min.js';
import 'froala-editor/js/plugins/word_paste.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/third_party/embedly.min.js';
import 'froala-editor/js/third_party/font_awesome.min.js';
import 'froala-editor/js/third_party/spell_checker.min.js';

import React, { useEffect, useRef } from 'react';
import { FileAttachment } from '@tuqqi/common';
import './styles.css'
const FroalaEditorComponent = require('react-froala-wysiwyg').default;
const Froalaeditor = require('froala-editor')


var changeDirection = function (this: any, dir: string, align: string) {
    // Wrap block tags.
    this.selection.save();
    this.html.wrap(true, true, true, true);
    this.selection.restore();

    // Get blocks.
    var elements = this.selection.blocks();

    // Save selection to restore it later.
    this.selection.save();

    for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        if (element != this.el) {
            this.$(element)
                .css('direction', dir)
                .css('text-align', align)
                .removeClass('fr-temp-div');
        }
    }

    // Unwrap temp divs.
    this.html.unwrap();

    // Restore selection.
    this.selection.restore();
}

interface Props1 {
    editMode?: boolean
    denyAutofocus?: boolean
    value: string
    onBlur?: () => void
    onChange?: (newHtml: string) => void
    onFilesChange?: (file: FileAttachment) => void
}

export function ArticleFieldEditComponent(props: Props1) {
    const loadingFiles = useRef(false)
    const { value, onBlur, onChange, onFilesChange, editMode } = props
    const ref = useRef<any | null>(null)

    useEffect(() => {
        if (ref && ref.current) {
            Froalaeditor.DefineIcon('rightToLeft', { SRC: `/resources/froala/RTL.svg`, template: 'image', ALT: 'Rtl' });
            Froalaeditor.RegisterCommand('rightToLeft', {
                title: 'RTL',
                focus: true,
                undo: true,
                refreshAfterCallback: true,
                callback: function () {
                    changeDirection.apply(this, ['rtl', 'right']);
                }
            })

            Froalaeditor.DefineIcon('leftToRight', { SRC: `/resources/froala/LTR.svg`, template: 'image', ALT: 'Ltr' });
            Froalaeditor.RegisterCommand('leftToRight', {
                title: 'LTR',
                focus: true,
                undo: true,
                refreshAfterCallback: true,
                callback: function () {
                    changeDirection.apply(this, ['ltr', 'left']);
                }
            })
        }
    }, [ref, onBlur])


    let buttons = ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'clearFormatting'];

    return <FroalaEditorComponent ref={ref}
        model={value}
        onModelChange={(newHtml: string) => onChange && onChange(newHtml)}
        config={{
            key: '9KH3cC4D4E4E3B2C2zsH-7xD-17bF6nablA3C11A8C6D2B4C4G2C3J4==',
            autofocus: props?.denyAutofocus ? false : true,
            typingTimer: 0,
            zIndex: 2501,
            heightMin: 155,
            linkAlwaysBlank: true,
            events: {
                'blur': () => {
                    !editMode && onBlur?.()
                },
                'file.beforeUpload': function (files: FileList, a: any) {
                    if(loadingFiles.current) return true
                },
                'image.uploaded': function (response: string) {
                    return true;
                },
                'file.uploaded': function (response: string) {
                    return true;
                },
                'video.uploaded': function (response: string) {
                    return true;
                },
                'image.error': () => {
                    loadingFiles.current = false
                },
                'file.error': () => {
                    loadingFiles.current = false
                },
                'video.error': (e: any) => {
                    console.log(e);
                    loadingFiles.current = false
                }
            },
            htmlAllowedEmptyTags: ['textarea', 'a', 'iframe', 'object', 'video', 'style','.fa'],
            toolbarButtons: {
                'moreText': {
                    'buttons': buttons,
                    'buttonsVisible': 3
                },
                'moreParagraph': {
                    'buttons': ['alignLeft', 'alignCenter', 'alignRight', 'leftToRight', 'rightToLeft', 'formatOLSimple', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'],
                    'buttonsVisible': 2
                },
                'moreRich': {
                    'buttons': ['insertLink', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertHR'],
                    'buttonsVisible': 0
                },
                'moreMisc': {
                    'buttons': ['undo', 'redo', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'],
                    'align': 'right',
                    'buttonsVisible': 0
                },
            }
        }} />
}
